export const V2_APP_GUIDE = Object.freeze({
  dashboard:
    "Open Dashboard to see today's nutrient cards, daily progress, safety summary, approved tips, and quote of the day.",
  profile:
    "Open Settings, complete your profile, and enter your current weight. Use the daily limits provided by your doctor or renal dietitian; the app does not invent limits.",
  weight:
    "Open Settings, complete your profile, and enter your current weight in the Weight field, then save your settings.",
  foodLogging:
    "Open Log Food, search or select a food, choose the serving and quantity, review the nutrient preview, then save. The app confirms only after the entry is actually saved.",
  customFoods:
    "Open Foods, choose Add Custom Food, enter the food name, serving, and nutrient values from a trusted label or source, then save it.",
  history:
    "Open History to review your saved food entries and nutrient totals by day.",
  dailyTotals:
    "Open Dashboard to review today's potassium, phosphorus, sodium, and protein totals. These totals come from your saved food entries.",
  nutrients:
    "Use the potassium, phosphorus, sodium, and protein cards on Dashboard to compare today's saved totals with the personal limits entered in Settings.",
  pushReminders:
    "Open Settings and allow browser notifications, then open Reminders, create or edit a reminder, and choose Push notification.",
  whatsappReminders:
    "Open Settings, add your WhatsApp number and enable WhatsApp reminders, then open Reminders and choose WhatsApp for the reminder channel.",
  bothReminderChannels:
    "Set up browser notifications and your WhatsApp number in Settings, then open Reminders and choose Both for the reminder channel.",
  passwordReset:
    "On the Login page, choose Forgot password, enter your account email, open the secure reset link sent to you, and set a new password on the Reset Password page.",
  medicalDisclaimer:
    "Dialysis Diet Pro is a support tool. It does not replace medical advice, dialysis treatment, or guidance from your doctor or renal dietitian. Always follow your healthcare team's limits and instructions.",
});

const GUIDE_TOPICS = [
  { pattern: /password|forgot|reset/i, key: "passwordReset" },
  { pattern: /both|push.*whatsapp|whatsapp.*push/i, key: "bothReminderChannels" },
  { pattern: /whatsapp/i, key: "whatsappReminders" },
  { pattern: /push|browser notification/i, key: "pushReminders" },
  { pattern: /custom food/i, key: "customFoods" },
  { pattern: /log food|food log|record food|add food/i, key: "foodLogging" },
  { pattern: /history|past food|previous food/i, key: "history" },
  { pattern: /weight/i, key: "weight" },
  { pattern: /profile|setup|settings/i, key: "profile" },
  { pattern: /daily total|today'?s total/i, key: "dailyTotals" },
  { pattern: /potassium|phosphorus|sodium|protein|nutrient/i, key: "nutrients" },
  { pattern: /dashboard|summary|progress/i, key: "dashboard" },
  { pattern: /medical|disclaimer|doctor|dietitian/i, key: "medicalDisclaimer" },
];

export function answerV2AppGuideQuestion(question = "") {
  const topic = GUIDE_TOPICS.find(({ pattern }) => pattern.test(String(question)));
  if (topic) return V2_APP_GUIDE[topic.key];

  return [
    "I can guide you through Dashboard, profile and weight setup, food logging, custom foods, History, nutrient totals, reminders, and password reset.",
    "Tell me which part you want to use, and I’ll give you the exact steps.",
  ].join(" ");
}
